<template>
  <div id="home">
    <nav-bar class="navbar" :current-page="'PROJECTS'" style="top: 0"></nav-bar>
    <div class="content" style="margin-top: 60px;">
      <project-list v-show="currentPage === 'PROJECT_LIST'" v-on:to-project-home="currentPage = 'PROJECT_HOME'"></project-list>
      <project-home v-show="currentPage === 'PROJECT_HOME'" v-on:back-to-list="currentPage = 'PROJECT_LIST'"></project-home>
    </div>
  </div>
</template>

<script>
import ProjectList from '../components/ProjectList.vue'
import ProjectHome from '../components/ProjectHome.vue'
import NavBar from '../components/NavBar.vue'

export default {
  name: 'Home',
  components: {
    ProjectList,
    ProjectHome,
    NavBar
  },
  methods: {
    signOut: function () {
      this.$store.dispatch('signOutUser')
    }
  },
  data () {
    return {
      currentPage: 'PROJECT_LIST'
    }
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.currentUserInfo
    }
  }
}

</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: top 0.3s;
}
.nav-animation-enter-active {
  transition: all .3s ease;
}
.nav-animation-leave-active {
  transition: all .3s ease;
}
.nav-animation-enter, .nav-animation-leave-to {
  transform: translateY(-80px);
  opacity: 0;
}
.content {
  box-sizing: border-box;
  padding: 24px 0;
  transition: all ease 0.2s;
}

@media screen and (max-width: 991px) {
  .content {
    padding: 16px 0;
  }
}
</style>
